import microuniversoApi from "app/api/microuniversoApi"
import { atualizarItemAction, sobrescreverInformacoesAction } from "app/redux/orcamentoSlice"
import store from "app/redux/store/store"
import { IOrcamento } from "app/types/IOrcamento"
import * as atualizacaoOrcamentoLegadoActions from 'app/redux/atualizacaoOrcamentoLegadoSlice'



declare var window:any

export type DefinirDespesasInclusas = {
    valorDespesasInclusas: number
}

export async function definirDespesasInclusas(input: DefinirDespesasInclusas) {
    
    const orcamentoAtualizado = await microuniversoApi.Orcamento.definirDespesasInclusas(
        store.getState().orcamento.IdentificadorOrcamento,
        input.valorDespesasInclusas
    )

    const atualizarOrcamentoLegadoERedux = () => {
        const orcamentoLegado = window.orcamentoController.model

        orcamentoLegado.atualizar(orcamentoAtualizado)

        var itensOrcamentoLegado = orcamentoLegado.get("ItensOrcamento");
        var valorDespesasInclusas = orcamentoLegado.get("ValorDespesasInclusas");

        if (itensOrcamentoLegado && ((valorDespesasInclusas ?? 0) == 0)) {
            itensOrcamentoLegado.each(function (model) {
                model.set("DespesasInclusas", false);
            });

            (store.getState().orcamento.ItensOrcamento ?? []).forEach(i => {
                store.dispatch(atualizarItemAction({
                    identificador: i.Identificador,
                    dados: {
                        DespesasInclusas: false
                    }
                }))
            })
            
        }

        
    }

    const atualizarEstado = () => {
        const orcamentoLegado = window.orcamentoController.model

        orcamentoLegado.atualizar(orcamentoAtualizado, true, true)

        store.dispatch(atualizacaoOrcamentoLegadoActions.atualizar(orcamentoAtualizado))
    }

    
    atualizarEstado()
}